import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var UserSiteDataErrorReason = /*#__PURE__*/function (UserSiteDataErrorReason) {
  UserSiteDataErrorReason["APS_NO_SITE_MATCH"] = "aps_no_site_match";
  UserSiteDataErrorReason["APS_EMPTY_RESULT"] = "aps_empty_result";
  UserSiteDataErrorReason["APS_PARTIAL_EMPTY_RESULT"] = "aps_partial_response_empty_result";
  return UserSiteDataErrorReason;
}({});
export var UserSiteDataError = /*#__PURE__*/function (_Error) {
  _inherits(UserSiteDataError, _Error);
  var _super = _createSuper(UserSiteDataError);
  function UserSiteDataError(reason, message) {
    var _this;
    _classCallCheck(this, UserSiteDataError);
    _this = _super.call(this, message);
    _this.name = 'UserSiteDataError';
    _this.reason = reason;
    return _this;
  }
  return _createClass(UserSiteDataError);
}( /*#__PURE__*/_wrapNativeSuper(Error));